window.addEventListener(
    'CookiebotOnConsentReady',
    function () {
        if (!Cookiebot.consent.marketing) return;

        var piDomain = 'go.universal-robots.cn';
        (function () {
            var s = document.createElement('script');
            s.type = 'text/javascript';
            s.async = true;
            s.src = '//' + piDomain + '/pdt.js';
            var c = document.getElementsByTagName('script')[0];
            c.parentNode.insertBefore(s, c);
            window['pdt'] =
                window['pdt'] ||
                function () {
                    (window['pdt'].cq = window['pdt'].cq || []).push(arguments);
                };
        })();

        pdt('create', 1024783 + 1000, 15057 + 1000, piDomain);
        pdt('setOptIn', true);
    },
    false,
);
